const Footer = () => {
    return (
        <footer>
            Made with React by{' '}
            <a href="https://github.com/mc6ril">
                <strong>Cyril Lesot</strong>
            </a>
        </footer>
    );
};

export default Footer;
